module.exports = __webpack_public_path__ + "static/media/website-icon.9d16e2bf.svg";